import { useEffect } from 'react';
import { getToken, onMessage } from 'firebase/messaging';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { messaging, db } from '../firebase/config';
import { useAuth } from '../contexts/AuthContext';

export function useFcmToken() {
  const { currentUser } = useAuth();

  useEffect(() => {
    if (!currentUser || !messaging) return;

    async function syncToken() {
      try {
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') return;

        const token = await getToken(messaging, {
          vapidKey: process.env.REACT_APP_FCM_VAPID_KEY,
        });
        if (!token) return;

        const userRef = doc(db, 'users', currentUser.uid);
        const snap = await getDoc(userRef);
        if (snap.data()?.fcmToken !== token) {
          await updateDoc(userRef, { fcmToken: token });
        }
      } catch {
        // Stille feil — push-støtte mangler eller tillatelse nektet
      }
    }

    syncToken();

    function handleVisibilityChange() {
      if (document.visibilityState === 'visible') syncToken();
    }

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [currentUser]);

  useEffect(() => {
    if (!messaging) return;
    const unsubscribe = onMessage(messaging, (payload) => {
      console.info('[FCM]', payload.notification?.title, payload.notification?.body);
    });
    return unsubscribe;
  }, []);
}
